import { createBrowserHistory }  from 'history'

export default createBrowserHistory()


// WEBPACK FOOTER //
// ./src/middlewares/history.js